enum Buttons {
  text = 'TEXT',
  icon = 'ICON',
}

export { Buttons };
